import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=38ea2f76&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=38ea2f76&prod&scoped=true&lang=less&"
import style1 from "./Light.vue?vue&type=style&index=1&id=38ea2f76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea2f76",
  null
  
)

export default component.exports